<template>
	<v-container class="register-page" v-if="isPageVisible">
		<div
			class="register-page__back"
			v-if="step === 2"
			@click="toStep1"
		>
			<v-icon class="register-page__back-icon mr-3">
				mdi-arrow-left-circle
			</v-icon>
			<span class=register-page__back-text>
				Back
			</span>
		</div>
		<div class="register-page__content" v-bind:style="{maxWidth: step === 1 ? '320px' : '480px'}">
			<h1
				:class="{
					'register-page__title': true,
					'mb-2': singUpMessage,
					'mb-5': !singUpMessage
				}"
			>
				Sing Up
			</h1>
			<h2
				v-if="singUpMessage"
				class="register-page__subtitle mb-5"
			>
				{{ singUpMessage }}
			</h2>
			<RegisterStep1Form
				v-if="step === 1"
				@submitStep1="handleSubmitStep1"
				:initFields="initFields"
			/>
			<RegisterStep2Form
				v-else
				:initFields="initFields"
				@cacheFields="cacheFields"
				@stepBack="stepBack"
			/>
			<p class="terms-of-use" v-html="policyAndTermText"></p>
		</div>
	</v-container>
</template>

<script>
import RegisterStep1Form from '@/components/Forms/RegisterStep1Form'
import RegisterStep2Form from '@/components/Forms/RegisterStep2Form'
import { mapGetters } from 'vuex'
export default {
	name: 'RegisterPage',
	components: {
		RegisterStep1Form,
		RegisterStep2Form
	},
	data() {
		return {
			step: 1,
			fields: {
				user_login: '',
				user_password: ''
			}
		}
	},
	methods: {
		handleSubmitStep1(payload) {
			this.fields = {...this.fields, ...payload}
			this.step = 2
		},
		toStep1() {
			this.step = 1
		},
		cacheFields(payload) {
			this.fields = payload
		},
		stepBack() {
			this.fields.user_login = ''
			this.fields.user_password = ''
			this.toStep1()
		}
	},
	computed: {
		...mapGetters('settings', ['login']),

		isPageVisible() {
			if (this.login) {
				return this.login.registration_url
			}
			return null
		},
		singUpMessage() {
			if (this.login) {
				return this.login.signup_message
			}
			return null
		},
		policyAndTermText() {
			const {
				license_text_signup: licenseText,
				signup_button: signUpButtonName
			} = this.login || {}

			const {
				privacy_policy: policy,
				terms_of_use: termOfUse
			} = this.baseCore || {}

			return licenseText
				.replace(/{%login.signup_button%}/g, signUpButtonName)
				.replace(/{%core.privacy_policy%}/g, policy)
				.replace(/{%core.terms_of_use%}/g, termOfUse)
				.replace(/href/g, 'target="_blank"href')
		},
		initFields() {
			return this.fields
		}
	},
	created() {
		if (this.login && !this.login.registration_url) {
			this.$router.push({
				name: 'welcome'
			})
		}
	}
}
</script>

<style lang="scss">
.register-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: Montserrat, sans-serif;

	@media (min-width: 781px) {
		overflow-y: auto;
		max-height: calc(100vh - 24px);
	}

	&__title {
		font-size: 36px;
		font-weight: 700;
		color: #4A4A4A;
		line-height: 43.88px;
	}
	&__subtitle {
		font-size: 16px;
		font-weight: 400;
		color: #4A4A4A;
		line-height: 19.5px;
	}

	&__back {
		margin-bottom: 100px;
		align-self: flex-start;
		display: flex;
		align-items: center;
		cursor: pointer;

		&-text {
			font-size: 15px;
			font-weight: 700;
			color: var(--accent-color);
			line-height: 18.3px;
			text-decoration: underline;
		}

		&-icon {
			color: var(--accent-color) !important;
		}
	}

	.terms-of-use {
		padding-top: 20px;
		max-width: 420px;
		width: 100%;
		color: #a0a0a0 !important;
		font-size: 12px;
		font-family: Montserrat, sans-serif;
		font-weight: 500;
		text-align: left;

		a {
			color: var(--link) !important;
		}
	}
}
</style>
